// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Venues_venues__dda02 {
  display: flex;
  justify-content: start;
  align-items: center;
  width: fit-content;
  gap: 4px;
  border-radius: 500px;
  border: 1px solid var(--border);
  padding: 8px 12px;
  margin: 0;
}
.Venues_venues__dda02 img {
  width: 16px;
  height: 16px;
  object-fit: cover;
  object-position: center;
}
.Venues_venues__dda02 span {
  font: var(--body-font-three);
  font-weight: 400;
  color: var(--secondary-Text);
}`, "",{"version":3,"sources":["webpack://./src/components/atoms/Venues/Venues.module.scss"],"names":[],"mappings":"AAAA;EACC,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,kBAAA;EACA,QAAA;EACA,oBAAA;EACA,+BAAA;EACA,iBAAA;EACA,SAAA;AACD;AACC;EACC,WAAA;EACA,YAAA;EACA,iBAAA;EACA,uBAAA;AACF;AAEC;EACC,4BAAA;EACA,gBAAA;EACA,4BAAA;AAAF","sourcesContent":[".venues {\r\n\tdisplay: flex;\r\n\tjustify-content: start;\r\n\talign-items: center;\r\n\twidth: fit-content;\r\n\tgap: 4px;\r\n\tborder-radius: 500px;\r\n\tborder: 1px solid var(--border);\r\n\tpadding: 8px 12px;\r\n\tmargin: 0;\r\n\r\n\timg {\r\n\t\twidth: 16px;\r\n\t\theight: 16px;\r\n\t\tobject-fit: cover;\r\n\t\tobject-position: center;\r\n\t}\r\n\r\n\tspan {\r\n\t\tfont: var(--body-font-three);\r\n\t\tfont-weight: 400;\r\n\t\tcolor: var(--secondary-Text);\r\n\t}\r\n}\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"venues": `Venues_venues__dda02`
};
export default ___CSS_LOADER_EXPORT___;
